import { createAction } from 'typesafe-actions';
import { TransactionArchiveResponse } from 'types/dto';
import { TransactionArchiveResult } from 'types/store';

export enum BankTransactionHandleAction {
  ArchiveRequest = 'BANK_TRANSACTION_ARCHIVE_REQUEST',
  ArchiveResponse = 'BANK_TRANSACTION_ARCHIVE_RESPONSE',
  ArchiveResult = 'BANK_TRANSACTION_ARCHIVE_RESULT',
  Error = 'BANK_TRANSACTION_HANDLE_ERROR',
  RestoreRequest = 'BANK_TRANSACTION_RESTORE_REQUEST',
  RestoreResponse = 'BANK_TRANSACTION_RESTORE_RESPONSE',
}

export const bankTransactionArchiveRequest = createAction(
  BankTransactionHandleAction.ArchiveRequest,
)<Array<string>>();
export const bankTransactionArchiveResponse = createAction(
  BankTransactionHandleAction.ArchiveResponse,
)<TransactionArchiveResponse>();
export const bankTransactionArchiveResult = createAction(
  BankTransactionHandleAction.ArchiveResult,
)<TransactionArchiveResult>();

export const bankTransactionHandleError = createAction(BankTransactionHandleAction.Error)<Error>();

export const bankTransactionRestoreRequest = createAction(
  BankTransactionHandleAction.RestoreRequest,
)<Array<string>>();
export const bankTransactionRestoreResponse = createAction(
  BankTransactionHandleAction.RestoreResponse,
)<Array<string>>();
